import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const DICT = {
  en: {
    "nav.home": "Home",
    "nav.products": "Products",
    "nav.services": "Services",
    "nav.portfolio": "Portfolio",
    "nav.about": "About us",
    "nav.contact": "Contact",
    "cta.quote": "Request a quote",
    "cta.explore": "Explore MATCH 2026",
    "cta.allProducts": "All products",
    "cta.allProjects": "All projects",
    "cta.startProject": "Start a project",
    "cta.workWithUs": "Work with us",
    "cta.sample": "Request sample box",
    "cta.downloadPdf": "Download product PDF",
    "cta.goBack": "Go back",
    "cta.detail": "Detail",
    "cta.viewProject": "View project",
    "cta.send": "Send enquiry",
    "cta.sending": "Sending...",
    "label.studio": "[ 02 // THE STUDIO ]",
    "label.products": "[ 03 // PRODUCTS ]",
    "label.capabilities": "[ 04 // CAPABILITIES ]",
    "label.philosophy": "[ 05 // PHILOSOPHY ]",
    "label.selectedWork": "[ 06 // SELECTED WORK ]",
    "label.clients": "[ 07 // TRUSTED BY ]",
    "home.productLines": "Three product\nlines",
    "home.portfolio": "Portfolio",
    "home.studioLead":
      "We mill wood into surfaces that hold light. Parametric relief, acoustic depth, and a tolerance of half a millimetre.",
    "home.ctaTitle": "Modular surfaces,\nmade to match",
    "home.ctaText":
      "Four CNC routed series in 6 mm MDF. Repeat, rotate and match panels into one continuous architectural surface.",
    "products.title": "Modular\nsurface systems",
    "products.lead":
      "Four repeatable panel systems. One architectural surface language. Designed for CNC routed 6 mm MDF.",
    "products.collections": "[ COLLECTIONS ]",
    "products.gallery": "Gallery",
    "services.title": "What we\nmanufacture",
    "portfolio.title": "Portfolio",
    "about.title": "Who we are,\nwhat we make",
    "about.partners": "[ FOUNDING PARTNERS ]",
    "contact.title": "Start a\nproject",
    "contact.lead":
      "Send us your drawings, wall areas or a reference image. We reply with a system proposal, sample box and indicative pricing.",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.company": "Company",
    "contact.area": "Wall area (m2)",
    "contact.system": "Panel system of interest",
    "contact.message": "Message",
    "contact.website": "Website",
    "contact.hours": "Studio hours",
    "footer.title": "Let's build a\nsurface together",
    "footer.navigate": "Navigate",
    "toast.sentTitle": "Enquiry received",
    "toast.sentText": "Thank you, our studio will reply within two working days.",
    "toast.missingTitle": "Missing details",
    "toast.missingText": "Name, email and message are required.",
    "hero.tag": "MATCH COLLECTION 2026 · CNC 6 MM MDF",
    "hero.hint": "DRAG · SWIPE · ARROWS",
    "hero.modules": "Modules",
    "hero.panel": "Panel",
    "hero.layouts": "Layouts",
    "home.productCta": "[ MATCH COLLECTION 2026 ]",
    "home.lines": "Product\nlines",
    "home.selectedWork": "Selected work",
    "products.download": "Download product PDF",
    "products.lines": "[ PRODUCT LINES ]",
    "products.series": "[ FOUR SERIES · ONE EDGE LOGIC ]",
    "portfolio.lead": "Delivered projects across retail, hospitality, healthcare, office, wellness and residential interiors.",
    "portfolio.empty": "No projects in this category.",
    "portfolio.back": "Back to portfolio",
    "detail.note": "[ PROJECT NOTE ]",
    "detail.next": "Next projects",
    "detail.client": "Client",
    "detail.location": "Location",
    "detail.year": "Year",
    "detail.typology": "Typology",
    "detail.scope": "Scope",
    "detail.notFound": "Project not found",
    "about.how": "[ HOW WE WORK ]",
    "about.studio": "[ THE STUDIO ]",
    "services.lead": "From algorithmic modelling to the final oiled surface, a single studio responsible for design, milling, finishing and installation.",
    "services.process": "[ HOW THE PROCESS WORKS ]",
    "services.processTitle": "Five steps from\nbrief to installed wall",
    "services.production": "[ PRODUCTION ]",
    "services.productionTitle": "Nested, milled,\nnumbered, shipped",
    "services.productionText": "Every project is nested for minimum waste, milled on a 5-axis bed, hand-sanded and finished with natural oil-wax. Modules arrive numbered against the installation drawing.",
    "contact.enquiry": "[ PROJECT ENQUIRY ]",
    "contact.selectSystem": "Select a system",
    "contact.custom": "Custom / not sure yet",
    "contact.office": "Office",
    "contact.hoursValue": "Mon to Fri, 09:00 - 18:00 (EET / EEST)",
    "contact.locations": "[ STUDIO LOCATIONS ]",
    "contact.twoStudios": "Two studios,\none production logic",
    "contact.mapNote": "Design and CNC production between Helsinki (FI) and Istanbul (TR)",
    "footer.getInTouch": "[ GET IN TOUCH ]",
    "footer.rights": "All rights reserved",
    "clients.label": "[ TRUSTED BY · RETAIL & HOSPITALITY GROUPS ]",
  },
  fi: {
    "nav.home": "Etusivu",
    "nav.products": "Tuotteet",
    "nav.services": "Palvelut",
    "nav.portfolio": "Portfolio",
    "nav.about": "Tietoa meist\u00e4",
    "nav.contact": "Ota yhteytt\u00e4",
    "cta.quote": "Pyyd\u00e4 tarjous",
    "cta.explore": "Tutustu MATCH 2026",
    "cta.allProducts": "Kaikki tuotteet",
    "cta.allProjects": "Kaikki projektit",
    "cta.startProject": "Aloita projekti",
    "cta.workWithUs": "Tehd\u00e4\u00e4n yhteisty\u00f6t\u00e4",
    "cta.sample": "Pyyd\u00e4 mallilaatikko",
    "cta.downloadPdf": "Lataa tuote-PDF",
    "cta.goBack": "Takaisin",
    "cta.detail": "Lis\u00e4tiedot",
    "cta.viewProject": "Katso projekti",
    "cta.send": "L\u00e4het\u00e4 kysely",
    "cta.sending": "L\u00e4hetet\u00e4\u00e4n...",
    "label.studio": "[ 02 // STUDIO ]",
    "label.products": "[ 03 // TUOTTEET ]",
    "label.capabilities": "[ 04 // OSAAMINEN ]",
    "label.philosophy": "[ 05 // FILOSOFIA ]",
    "label.selectedWork": "[ 06 // VALITUT TY\u00d6T ]",
    "label.clients": "[ 07 // ASIAKKAAMME ]",
    "home.productLines": "Kolme\ntuotelinjaa",
    "home.portfolio": "Portfolio",
    "home.studioLead":
      "Jyrsimme puusta pintoja, jotka kantavat valoa. Parametrinen reliefi, akustinen syvyys ja puolen millimetrin toleranssi.",
    "home.ctaTitle": "Modulaariset pinnat,\njotka sopivat yhteen",
    "home.ctaText":
      "Nelj\u00e4 CNC-jyrsitty\u00e4 sarjaa 6 mm MDF-levylle. Toista, k\u00e4\u00e4nn\u00e4 ja yhdist\u00e4 paneelit yhdeksi jatkuvaksi arkkitehtoniseksi pinnaksi.",
    "products.title": "Modulaariset\npintaj\u00e4rjestelm\u00e4t",
    "products.lead":
      "Nelj\u00e4 toistettavaa paneelij\u00e4rjestelm\u00e4\u00e4. Yksi arkkitehtoninen pintakieli. Suunniteltu CNC-jyrsitylle 6 mm MDF-levylle.",
    "products.collections": "[ KOKOELMAT ]",
    "products.gallery": "Galleria",
    "services.title": "Mit\u00e4 me\nvalmistamme",
    "portfolio.title": "Portfolio",
    "about.title": "Keit\u00e4 olemme,\nmit\u00e4 teemme",
    "about.partners": "[ PERUSTAJAOSAKKAAT ]",
    "contact.title": "Aloita\nprojekti",
    "contact.lead":
      "L\u00e4het\u00e4 meille piirustukset, sein\u00e4pinta-alat tai referenssikuva. Vastaamme j\u00e4rjestelm\u00e4ehdotuksella, mallilaatikolla ja suuntaa antavalla hinnalla.",
    "contact.name": "Nimi",
    "contact.email": "S\u00e4hk\u00f6posti",
    "contact.company": "Yritys",
    "contact.area": "Sein\u00e4pinta-ala (m2)",
    "contact.system": "Kiinnostava paneelij\u00e4rjestelm\u00e4",
    "contact.message": "Viesti",
    "contact.website": "Verkkosivu",
    "contact.hours": "Studion aukioloajat",
    "footer.title": "Rakennetaan\npinta yhdess\u00e4",
    "footer.navigate": "Valikko",
    "toast.sentTitle": "Kysely vastaanotettu",
    "toast.sentText": "Kiitos, vastaamme kahden ty\u00f6p\u00e4iv\u00e4n sis\u00e4ll\u00e4.",
    "toast.missingTitle": "Puuttuvat tiedot",
    "toast.missingText": "Nimi, s\u00e4hk\u00f6posti ja viesti ovat pakollisia.",
    "hero.tag": "MATCH COLLECTION 2026 · CNC 6 MM MDF",
    "hero.hint": "VED\u00c4 · PYYHK\u00c4ISE · NUOLET",
    "hero.modules": "Moduulit",
    "hero.panel": "Paneeli",
    "hero.layouts": "Asettelut",
    "home.productCta": "[ MATCH-KOKOELMA 2026 ]",
    "home.lines": "Tuote\nlinjat",
    "home.selectedWork": "Valitut ty\u00f6t",
    "products.download": "Lataa tuote-PDF",
    "products.lines": "[ TUOTELINJAT ]",
    "products.series": "[ NELJ\u00c4 SARJAA · YKSI REUNALOGIIKKA ]",
    "portfolio.lead": "Toteutetut projektit myym\u00e4l\u00e4-, hotelli-, terveydenhuolto-, toimisto-, hyvinvointi- ja asuintiloissa.",
    "portfolio.empty": "T\u00e4ss\u00e4 kategoriassa ei ole projekteja.",
    "portfolio.back": "Takaisin portfolioon",
    "detail.note": "[ PROJEKTIN KUVAUS ]",
    "detail.next": "Seuraavat projektit",
    "detail.client": "Asiakas",
    "detail.location": "Sijainti",
    "detail.year": "Vuosi",
    "detail.typology": "Tyyppi",
    "detail.scope": "Laajuus",
    "detail.notFound": "Projektia ei l\u00f6ytynyt",
    "about.how": "[ N\u00c4IN TY\u00d6SKENTELEMME ]",
    "about.studio": "[ STUDIO ]",
    "services.lead": "Algoritmisesta mallinnuksesta valmiiseen \u00f6ljyttyyn pintaan: yksi studio vastaa suunnittelusta, jyrsinn\u00e4st\u00e4, viimeistelyst\u00e4 ja asennuksesta.",
    "services.process": "[ N\u00c4IN PROSESSI ETENEE ]",
    "services.processTitle": "Viisi askelta briefist\u00e4\nasennettuun sein\u00e4\u00e4n",
    "services.production": "[ TUOTANTO ]",
    "services.productionTitle": "Nestattu, jyrsitty,\nnumeroitu, toimitettu",
    "services.productionText": "Jokainen projekti nestataan minimihukalla, jyrsit\u00e4\u00e4n 5-akselisella koneella, hiotaan k\u00e4sin ja viimeistell\u00e4\u00e4n luonnon \u00f6ljyvahalla. Moduulit saapuvat numeroituina asennuspiirustuksen mukaan.",
    "contact.enquiry": "[ PROJEKTIKYSELY ]",
    "contact.selectSystem": "Valitse j\u00e4rjestelm\u00e4",
    "contact.custom": "Mittatilaus / en ole varma",
    "contact.office": "toimisto",
    "contact.hoursValue": "Ma - pe, 09:00 - 18:00 (EET / EEST)",
    "contact.locations": "[ STUDIOIDEN SIJAINNIT ]",
    "contact.twoStudios": "Kaksi studiota,\nyksi tuotantologiikka",
    "contact.mapNote": "Suunnittelu ja CNC-tuotanto Helsingin (FI) ja Istanbulin (TR) v\u00e4lill\u00e4",
    "footer.getInTouch": "[ OTA YHTEYTT\u00c4 ]",
    "footer.rights": "Kaikki oikeudet pid\u00e4tet\u00e4\u00e4n",
    "clients.label": "[ ASIAKKAAMME · MYYM\u00c4L\u00c4- JA HOTELLIKONSERNIT ]",
  },
  tr: {
    "nav.home": "Anasayfa",
    "nav.products": "Ürünler",
    "nav.services": "Hizmetler",
    "nav.portfolio": "Portföy",
    "nav.about": "Hakkımızda",
    "nav.contact": "İletişim",
    "cta.quote": "Teklif alın",
    "cta.explore": "MATCH 2026'yı keşfedin",
    "cta.allProducts": "Tüm ürünler",
    "cta.allProjects": "Tüm projeler",
    "cta.startProject": "Projeye başlayın",
    "cta.workWithUs": "Bizimle çalışın",
    "cta.sample": "Numune kutusu isteyin",
    "cta.downloadPdf": "Ürün PDF'ini indirin",
    "cta.goBack": "Geri dön",
    "cta.detail": "Detay",
    "cta.viewProject": "Projeyi görüntüle",
    "cta.send": "Talebi gönder",
    "cta.sending": "Gönderiliyor...",
    "label.studio": "[ 02 // STÜDYO ]",
    "label.products": "[ 03 // ÜRÜNLER ]",
    "label.capabilities": "[ 04 // YETKİNLİKLER ]",
    "label.philosophy": "[ 05 // FELSEFE ]",
    "label.selectedWork": "[ 06 // SEÇİLMİŞ İŞLER ]",
    "label.clients": "[ 07 // REFERANSLAR ]",
    "home.productLines": "Üç ürün\nhattı",
    "home.portfolio": "Portföy",
    "home.studioLead":
      "Ahşabı ışığı tutan yüzeylere dönüştürüyoruz. Parametrik rölyef, akustik derinlik ve yarım milimetre tolerans.",
    "home.ctaTitle": "Modüler yüzeyler,\nuyum için tasarlandı",
    "home.ctaText":
      "6 mm MDF üzerine CNC ile işlenmiş dört seri. Panelleri tekrarlayın, döndürün ve kesintisiz tek bir mimari yüzeyde birleştirin.",
    "products.title": "Modüler\nyüzey sistemleri",
    "products.lead":
      "Dört tekrarlanabilir panel sistemi. Tek bir mimari yüzey dili. 6 mm CNC işlenmiş MDF için tasarlandı.",
    "products.collections": "[ KOLEKSİYONLAR ]",
    "products.gallery": "Galeri",
    "services.title": "Neler\nüretiyoruz",
    "portfolio.title": "Portföy",
    "about.title": "Kimiz,\nne üretiyoruz",
    "about.partners": "[ KURUCU ORTAKLAR ]",
    "contact.title": "Projeye\nbaşlayın",
    "contact.lead":
      "Çizimlerinizi, duvar alanlarınızı veya bir referans görselini gönderin. Sistem önerisi, numune kutusu ve ön fiyatla dönüş yapıyoruz.",
    "contact.name": "İsim",
    "contact.email": "E-posta",
    "contact.company": "Firma",
    "contact.area": "Duvar alanı (m2)",
    "contact.system": "İlgilendiğiniz panel sistemi",
    "contact.message": "Mesaj",
    "contact.website": "Web sitesi",
    "contact.hours": "Stüdyo saatleri",
    "footer.title": "Birlikte bir\nyüzey inşa edelim",
    "footer.navigate": "Menü",
    "toast.sentTitle": "Talebiniz alındı",
    "toast.sentText": "Teşekkürler, stüdyomuz iki iş günü içinde dönüş yapacak.",
    "toast.missingTitle": "Eksik bilgi",
    "toast.missingText": "İsim, e-posta ve mesaj alanları zorunludur.",
    "hero.tag": "MATCH KOLEKSİYONU 2026 · CNC 6 MM MDF",
    "hero.hint": "SÜRÜKLE · KAYDIR · OKLAR",
    "hero.modules": "Modüller",
    "hero.panel": "Panel",
    "hero.layouts": "Dizilimler",
    "home.productCta": "[ MATCH KOLEKSİYONU 2026 ]",
    "home.lines": "Ürün\nhatları",
    "home.selectedWork": "Seçilmiş işler",
    "products.download": "Ürün PDF'ini indirin",
    "products.lines": "[ ÜRÜN HATLARI ]",
    "products.series": "[ DÖRT SERİ · TEK KENAR MANTIĞI ]",
    "portfolio.lead": "Perakende, konaklama, sağlık, ofis, wellness ve konut iç mekanlarında tamamlanmış projeler.",
    "portfolio.empty": "Bu kategoride proje bulunmuyor.",
    "portfolio.back": "Portföye dön",
    "detail.note": "[ PROJE NOTU ]",
    "detail.next": "Sonraki projeler",
    "detail.client": "Müşteri",
    "detail.location": "Konum",
    "detail.year": "Yıl",
    "detail.typology": "Tipoloji",
    "detail.scope": "Kapsam",
    "detail.notFound": "Proje bulunamadı",
    "about.how": "[ NASIL ÇALIŞIYORUZ ]",
    "about.studio": "[ STÜDYO ]",
    "services.lead": "Algoritmik modellemeden son yağlı yüzeye kadar; tasarım, işleme, finisaj ve montajdan tek bir stüdyo sorumlu.",
    "services.process": "[ SÜREÇ NASIL İŞLİYOR ]",
    "services.processTitle": "Briften montajlı duvara\nbeş adım",
    "services.production": "[ ÜRETİM ]",
    "services.productionTitle": "Yerleştirildi, işlendi,\nnumaralandı, sevk edildi",
    "services.productionText": "Her proje minimum fire için yerleştirilir, 5 eksenli tezgahta işlenir, elde zımparalanır ve doğal yağ-vaks ile bitirilir. Modüller montaj çizimine göre numaralanmış olarak ulaşır.",
    "contact.enquiry": "[ PROJE TALEBİ ]",
    "contact.selectSystem": "Bir sistem seçin",
    "contact.custom": "Özel / henüz emin değilim",
    "contact.office": "ofis",
    "contact.hoursValue": "Pazartesi - Cuma, 09:00 - 18:00 (EET / EEST)",
    "contact.locations": "[ STÜDYO KONUMLARI ]",
    "contact.twoStudios": "İki stüdyo,\ntek üretim mantığı",
    "contact.mapNote": "Helsinki (FI) ve İstanbul (TR) arasında tasarım ve CNC üretimi",
    "footer.getInTouch": "[ İLETİŞİME GEÇİN ]",
    "footer.rights": "Tüm hakları saklıdır",
    "clients.label": "[ REFERANSLAR · PERAKENDE VE KONAKLAMA GRUPLARI ]",
  },
  es: {
    "nav.home": "Inicio",
    "nav.products": "Productos",
    "nav.services": "Servicios",
    "nav.portfolio": "Portafolio",
    "nav.about": "Sobre nosotros",
    "nav.contact": "Contacto",
    "cta.quote": "Solicitar presupuesto",
    "cta.explore": "Descubre MATCH 2026",
    "cta.allProducts": "Todos los productos",
    "cta.allProjects": "Todos los proyectos",
    "cta.startProject": "Iniciar un proyecto",
    "cta.workWithUs": "Trabaja con nosotros",
    "cta.sample": "Solicitar caja de muestras",
    "cta.downloadPdf": "Descargar PDF del producto",
    "cta.goBack": "Volver",
    "cta.detail": "Detalle",
    "cta.viewProject": "Ver proyecto",
    "cta.send": "Enviar consulta",
    "cta.sending": "Enviando...",
    "label.studio": "[ 02 // EL ESTUDIO ]",
    "label.products": "[ 03 // PRODUCTOS ]",
    "label.capabilities": "[ 04 // CAPACIDADES ]",
    "label.philosophy": "[ 05 // FILOSOFÍA ]",
    "label.selectedWork": "[ 06 // TRABAJOS SELECCIONADOS ]",
    "label.clients": "[ 07 // CONFÍAN EN NOSOTROS ]",
    "home.productLines": "Tres líneas\nde producto",
    "home.portfolio": "Portafolio",
    "home.studioLead":
      "Fresamos la madera para crear superficies que sostienen la luz. Relieve paramétrico, profundidad acústica y una tolerancia de medio milímetro.",
    "home.ctaTitle": "Superficies modulares,\nhechas para encajar",
    "home.ctaText":
      "Cuatro series fresadas por CNC en MDF de 6 mm. Repite, gira y combina los paneles en una única superficie arquitectónica continua.",
    "products.title": "Sistemas de\nsuperficie modulares",
    "products.lead":
      "Cuatro sistemas de paneles repetibles. Un solo lenguaje de superficie arquitectónica. Diseñados para MDF de 6 mm fresado por CNC.",
    "products.collections": "[ COLECCIONES ]",
    "products.gallery": "Galería",
    "services.title": "Lo que\nfabricamos",
    "portfolio.title": "Portafolio",
    "about.title": "Quiénes somos,\nqué hacemos",
    "about.partners": "[ SOCIOS FUNDADORES ]",
    "contact.title": "Inicia un\nproyecto",
    "contact.lead":
      "Envíanos tus planos, las áreas de pared o una imagen de referencia. Respondemos con una propuesta de sistema, caja de muestras y precio indicativo.",
    "contact.name": "Nombre",
    "contact.email": "Correo electrónico",
    "contact.company": "Empresa",
    "contact.area": "Área de pared (m2)",
    "contact.system": "Sistema de panel de interés",
    "contact.message": "Mensaje",
    "contact.website": "Sitio web",
    "contact.hours": "Horario del estudio",
    "footer.title": "Construyamos una\nsuperficie juntos",
    "footer.navigate": "Navegar",
    "toast.sentTitle": "Consulta recibida",
    "toast.sentText": "Gracias, nuestro estudio responderá en dos días laborables.",
    "toast.missingTitle": "Faltan datos",
    "toast.missingText": "El nombre, el correo electrónico y el mensaje son obligatorios.",
    "hero.tag": "COLECCIÓN MATCH 2026 · CNC MDF 6 MM",
    "hero.hint": "ARRASTRA · DESLIZA · FLECHAS",
    "hero.modules": "Módulos",
    "hero.panel": "Panel",
    "hero.layouts": "Composiciones",
    "home.productCta": "[ COLECCIÓN MATCH 2026 ]",
    "home.lines": "Líneas de\nproducto",
    "home.selectedWork": "Trabajos seleccionados",
    "products.download": "Descargar PDF del producto",
    "products.lines": "[ LÍNEAS DE PRODUCTO ]",
    "products.series": "[ CUATRO SERIES · UNA LÓGICA DE BORDE ]",
    "portfolio.lead": "Proyectos entregados en interiores de retail, hostelería, salud, oficinas, wellness y vivienda.",
    "portfolio.empty": "No hay proyectos en esta categoría.",
    "portfolio.back": "Volver al portafolio",
    "detail.note": "[ NOTA DEL PROYECTO ]",
    "detail.next": "Siguientes proyectos",
    "detail.client": "Cliente",
    "detail.location": "Ubicación",
    "detail.year": "Año",
    "detail.typology": "Tipología",
    "detail.scope": "Alcance",
    "detail.notFound": "Proyecto no encontrado",
    "about.how": "[ CÓMO TRABAJAMOS ]",
    "about.studio": "[ EL ESTUDIO ]",
    "services.lead": "Del modelado algorítmico a la superficie aceitada final: un único estudio responsable del diseño, el fresado, el acabado y la instalación.",
    "services.process": "[ CÓMO FUNCIONA EL PROCESO ]",
    "services.processTitle": "Cinco pasos del briefing\nal muro instalado",
    "services.production": "[ PRODUCCIÓN ]",
    "services.productionTitle": "Anidado, fresado,\nnumerado, enviado",
    "services.productionText": "Cada proyecto se anida para minimizar el desperdicio, se fresa en una mesa de 5 ejes, se lija a mano y se termina con aceite-cera natural. Los módulos llegan numerados según el plano de instalación.",
    "contact.enquiry": "[ CONSULTA DE PROYECTO ]",
    "contact.selectSystem": "Selecciona un sistema",
    "contact.custom": "Personalizado / aún no lo sé",
    "contact.office": "oficina",
    "contact.hoursValue": "De lunes a viernes, 09:00 - 18:00 (EET / EEST)",
    "contact.locations": "[ UBICACIONES DE LOS ESTUDIOS ]",
    "contact.twoStudios": "Dos estudios,\nuna lógica de producción",
    "contact.mapNote": "Diseño y producción CNC entre Helsinki (FI) y Estambul (TR)",
    "footer.getInTouch": "[ CONTACTA ]",
    "footer.rights": "Todos los derechos reservados",
    "clients.label": "[ CONFÍAN EN NOSOTROS · GRUPOS DE RETAIL Y HOSTELERÍA ]",
  },
};

const I18nContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export const LANGS = ["en", "fi", "tr", "es"];

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const q = new URLSearchParams(window.location.search).get("lang");
    if (LANGS.includes(q)) return q;
    const saved = localStorage.getItem("hrd_lang");
    return LANGS.includes(saved) ? saved : "en";
  });

  useEffect(() => {
    localStorage.setItem("hrd_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: (key) => (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key,
      // picks the right value from a localized object coming from the API
      loc: (obj, fallback = "") =>
        !obj ? fallback : obj[lang] || obj.en || obj.fi || fallback,
    }),
    [lang]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
